import { AudioTrackEncodeType } from './types.ts';

export function translateCodecToEncodingType(codec: string | undefined) {
    if (codec == null) {
        return AudioTrackEncodeType.UNKNOWN;
    }

    // Split the codec string into base and profile parts
    const parts = codec.split('.');
    const base = parts[0];
    parts.shift();
    const profile = parts.join('.').toLowerCase();

    // Check for specific codec and profile combinations
    if (base === 'mp4a') {
        // MPEG (MP3)
        if (profile === '69' || profile === '6b' || profile === '40.34') {
            return AudioTrackEncodeType.MPEG;
        }
        // AAC
        if (
            profile === '66' ||
            profile === '67' ||
            profile === '68' ||
            profile === '40.2' ||
            profile === '40.02' ||
            profile === '40.5' ||
            profile === '40.05' ||
            profile === '40.29' ||
            profile === '40.42'
        ) {
            return AudioTrackEncodeType.AAC;
        }
        // AC3 (Dolby Digital)
        if (profile === 'a5') {
            return AudioTrackEncodeType.AC3;
        }
        // EC3 (Dolby Digital Plus)
        if (profile === 'a6') {
            return AudioTrackEncodeType.AC3;
        }
        // DTS:X
        if (profile === 'b2') {
            return AudioTrackEncodeType.DTS;
        }
        // DTS Digital Surround
        if (profile === 'a9') {
            return AudioTrackEncodeType.DTS;
        }
    }

    // Check for normalized codec names
    if (base === 'aac') {
        return AudioTrackEncodeType.AAC;
    }
    if (base === 'ac-3' || base === 'ec-3') {
        return AudioTrackEncodeType.AC3;
    }
    if (base === 'dts' || base === 'dtsc' || base === 'dtsx') {
        return AudioTrackEncodeType.DTS;
    }
    if (base === 'mp3') {
        return AudioTrackEncodeType.MPEG;
    }

    return AudioTrackEncodeType.UNKNOWN;
}
